import React from 'react';
import './MessengerDmMessages.css';
import './MessageRow.css';

export type MessengerMessageAlignment = 'user' | 'assistant';

export interface MessengerMessageRowProps {
  alignment: MessengerMessageAlignment;
  sameAsPrev?: boolean;
  animateEnter?: boolean;
  children: React.ReactNode;
  meta?: React.ReactNode;
  /** Ряд на всю ширину ленты (фото+подпись в DM), иначе wrapper с flex-end остаётся по intrinsic картинки */
  wrapperClassName?: string;
}

export function MessengerMessageRow({
  alignment,
  sameAsPrev,
  animateEnter = false,
  children,
  meta,
  wrapperClassName,
}: MessengerMessageRowProps): React.ReactNode {
  const alignClass =
    alignment === 'user' ? 'chatAssistant__messageWrapper_user' : 'chatAssistant__messageWrapper_assistant';

  return (
    <div
      className={[
        'chatAssistant__messageWrapper',
        animateEnter ? 'chatAssistant__messageWrapper_messengerEnter' : '',
        alignClass,
        sameAsPrev ? 'chatAssistant__messageWrapper_sameUser' : '',
        wrapperClassName ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
      {meta}
    </div>
  );
}
